import { faCat, faDog, faTurtle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import React from 'react';
import { PetType } from 'types/Pet';

import classes from './PetAvatar.module.scss';

interface PetAvatarProps {
    size?: number;
    image?: string;
    petType: PetType;
    onClick?: () => void;
}

export const PetAvatar: React.FC<PetAvatarProps> = props => {
    const petTypeIcon = React.useMemo(() => {
        switch (props.petType.id) {
            case 'dogs':
                return faDog;
            case 'cats':
                return faCat;
            default:
                return faTurtle;
        }
    }, [props.petType]);

    return (
        <div
            data-clickable={!!props.onClick}
            className={clsx(classes.root, classes[props.petType.id])}
            style={{ width: props.size, height: props.size }}
            onClick={props.onClick}
        >
            {props.image ? (
                <img src={props.image} alt={props.petType.id} className={classes.avatar} />
            ) : (
                <FontAwesomeIcon icon={petTypeIcon} />
            )}
        </div>
    );
};
